import { render } from "./loading-overlay.vue?vue&type=template&id=28788acf"
import script from "./loading-overlay.vue?vue&type=script&lang=js"
export * from "./loading-overlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__